var _style, _rect, _path, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _ellipse, _ellipse2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _ellipse3, _path17, _ellipse4, _path18, _ellipse5, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoneCheckingTy9A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a8c3e3ad-ef53-4a9e-a620-842318013c49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 967.9 731.6",
    style: {
      enableBackground: "new 0 0 967.9 731.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:#CCCCCC;}\n\t.st4{fill:#A0616A;}\n\t.st5{opacity:0.1;enable-background:new    ;}\n\t.st6{fill:url(#SVGID_1_);}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_00000021802225439323637920000006737542834410207907_);}\n\t.st9{fill:url(#SVGID_00000145033501024657146610000000991176554889094815_);}\n\t.st10{fill:#57B894;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168.5,
    y: 448.6,
    transform: "matrix(0.5591 -0.8291 0.8291 0.5591 -349.0625 447.778)",
    className: "st0",
    width: 156,
    height: 207
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.9,656.6l-1.8-0.9c23.1-44.6,10.7-102.6-3.7-143.3c-9.8-27.4-22.3-53.7-37.3-78.7l1.7-1.1 c15.1,25.1,27.6,51.5,37.5,79.1C121.9,552.8,134.3,611.3,110.9,656.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4,
    y: 467.6,
    transform: "matrix(0.1798 -0.9837 0.9837 0.1798 -360.4923 504.8771)",
    className: "st1",
    width: 72.2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 480.9,
    transform: "matrix(0.7321 -0.6812 0.6812 0.7321 -341.1592 192.7808)",
    className: "st1",
    width: 2,
    height: 98.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 595.6,
    transform: "matrix(0.5858 -0.8104 0.8104 0.5858 -423.0323 365.4058)",
    className: "st1",
    width: 58,
    height: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 134,
    cy: 404.1,
    r: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 25,
    cy: 481.1,
    r: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 69,
    cy: 491.1,
    r: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 49,
    cy: 530.1,
    r: 10
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 174,
    cy: 555.1,
    r: 10
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 141,
    cy: 566.1,
    r: 10
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 164,
    cy: 598.1,
    r: 10
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 59,
    cy: 416.1,
    r: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512,667.1c21.2,22.7-1.8,102.2-256,43C118.3,678,0,678.7,0,667.1s114.6,1,256,1S504.1,658.6,512,667.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,667.1c21.2,22.7-1.8,102.2-256,43C118.3,678,0,678.7,0,667.1s114.6,1,256,1S504.1,658.6,512,667.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M512,667.1c21.2,22.7-1.8,80.2-256,21C118.3,656,0,678.7,0,667.1s114.6-21,256-21S504.1,658.6,512,667.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.8,159.1h11.5c15.2,0,27.6,12.4,27.6,27.6c0,0,0,0,0,0v39.1l0,0h-66.7l0,0v-39.1 C218.2,171.5,230.5,159.1,245.8,159.1L245.8,159.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M239.3,212.9c0,0,2.8,22.4-3.5,23.8s-9.1,9.8-9.1,9.8l21,13.3l21.7-4.2l-2.1-16.1c0,0-5.6-16.1-2.8-26.6 S239.3,212.9,239.3,212.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.3,212.9c0,0,2.8,22.4-3.5,23.8s-9.1,9.8-9.1,9.8l21,13.3l21.7-4.2l-2.1-16.1c0,0-5.6-16.1-2.8-26.6 S239.3,212.9,239.3,212.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.3,472.4l5.6,36.4c0,0-1.4,37.1,8.4,69.9l9.8,32.9l9.8-11.2l2.8-44.8c0,0,0.7-16.1-2.1-28.7l2.1-58.8 L211.3,472.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.1,466.1l4.9,63.6c0,0-2.1,67.8-2.8,69.9s14,4.9,14,4.9s22.4-53.2,15.4-95.1c0,0-4.2-35.7,1.4-44.8 S263.1,466.1,263.1,466.1z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 251.2,
    cy: 199.6,
    r: 24.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.6,242.3c0,0,2.8,10.5,16.1,9.8s19.6-12.6,19.6-12.6s16.1,8.4,23.8,7.7l-2.1,34.3c0,0-13.3,36.4-10.5,44.8 s59.5,96.5,52.5,130.8c0,0,7,9.8-19.6,11.9s-25.9-2.8-47.6,7s-51.8,4.2-58.8,2.8s-31.5-5.6-31.5-5.6s5.6-103.5,37.8-138.5l-0.7-62.9 l-2.8-23.8c0,0,22.6-11.2,23.2-8.4L231.6,242.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.1,289.2c0,0,35.7,22.4,21.7,31.5s-63.9,32-63.9,32s-38.2-18-28.4-25s26.6,12.6,26.6,12.6l43.4-25.9 l-11.2-12.6L335.1,289.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.7,308.1v102.1c0,0-3.5,39.2,9.8,36.4s2.8-37.8,2.8-37.8l4.2-60.2V315L189.7,308.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247,583.6c0,0-6.3,13.3-19.6,5.6c0,0,3.5,11.9,3.5,14.7s3.5,17.5,4.9,18.9s0,32.2,7,33.6s13.3-16.1,13.3-22.4 s-2.1-26.6-2.1-26.6s1.4-13.3-6.3-17.5L247,583.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.4,599l-19.6-2.8l-4.2,16.8c0,0-11.2,30.1-11.9,35s-13.3,25.2-2.1,25.2s22.4,0.7,24.5-5.6s6.3-28,9.8-35.7 s-1.4-15.4-1.4-15.4L283.4,599z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.8,250l6.3-2.8c0,0,6.3,0,16.1,11.2c9.8,11.2,35.7,33.6,35.7,33.6s-17.5,17.5-21.7,16.1 c-4.2-1.4-36.4-32.2-36.4-32.2V250z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.3,247.9h-3.5c0,0-14.7,1.4-16.8,19.6c-2.1,18.2-5.6,39.9-7,42s18.2,11.2,21.7,11.2s9.1-54.6,9.1-54.6 L211.3,247.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "269.4,188.5 235.7,188.5 228.1,171 275.1,171 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9605 -0.2783 0.2783 0.9605 -45.8754 70.8339)",
    className: "st4",
    cx: 226.5,
    cy: 197,
    rx: 1.7,
    ry: 4.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2783 -0.9605 0.9605 0.2783 8.0879 407.5395)",
    className: "st4",
    cx: 275.2,
    cy: 198.4,
    rx: 4.5,
    ry: 1.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: -2.9,
    transform: "matrix(0.484 -0.8751 0.8751 0.484 177.0443 736.4451)",
    className: "st0",
    width: 254,
    height: 442
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.8796,
    y1: 278.0625,
    x2: 595.8796,
    y2: 278.0625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 448.9,
    y: 181.6,
    className: "st6",
    width: 147,
    height: 193
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 489.4,
    y: 212.1,
    className: "st7",
    width: 66,
    height: 66
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 464.4,
    y: 292.1,
    className: "st7",
    width: 116,
    height: 8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 464.4,
    y: 314.1,
    className: "st7",
    width: 116,
    height: 8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 464.4,
    y: 336.1,
    className: "st7",
    width: 116,
    height: 8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009580496766403570320000009828622392108446848_",
    gradientUnits: "userSpaceOnUse",
    x1: 760.8796,
    y1: 447.0625,
    x2: 907.8796,
    y2: 447.0625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 760.9,
    y: 350.6,
    style: {
      fill: "url(#SVGID_00000009580496766403570320000009828622392108446848_)"
    },
    width: 147,
    height: 193
  }), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 782.4,
    y: 376.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 782.4,
    y: 402.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 782.4,
    y: 428.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 782.4,
    y: 454.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 782.4,
    y: 480.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 782.4,
    y: 506.1,
    className: "st7",
    width: 104,
    height: 12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038392688467314680700000016842345319777854085_",
    gradientUnits: "userSpaceOnUse",
    x1: 717.8796,
    y1: 122.0625,
    x2: 864.8796,
    y2: 122.0625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 717.9,
    y: 25.6,
    style: {
      fill: "url(#SVGID_00000038392688467314680700000016842345319777854085_)"
    },
    width: 147,
    height: 193
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 739.4,
    y: 90.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 739.4,
    y: 116.1,
    className: "st7",
    width: 104,
    height: 12
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 739.4,
    y: 142.1,
    className: "st7",
    width: 104,
    height: 12
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 862,
    cy: 25.4,
    rx: 17.8,
    ry: 17.8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M862,4.5c-11.7,0-21.2,9.5-21.2,21.2c0,11.7,9.5,21.2,21.2,21.2c11.7,0,21.2-9.5,21.2-21.2c0,0,0,0,0,0 C883.2,14.1,873.7,4.6,862,4.5z M857.7,37.1l-10.9-10.9l3-3l7.8,7.8l16.5-16.5l3,3L857.7,37.1L857.7,37.1z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 908,
    cy: 346.4,
    rx: 17.8,
    ry: 17.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M908,325.5c-11.7,0-21.2,9.5-21.2,21.2c0,11.7,9.5,21.2,21.2,21.2c11.7,0,21.2-9.5,21.2-21.2 C929.2,335.1,919.7,325.6,908,325.5z M903.7,358.1l-10.9-10.9l3-3l7.8,7.8l16.5-16.5l3,3L903.7,358.1L903.7,358.1z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 596,
    cy: 179.4,
    rx: 17.8,
    ry: 17.8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M596,158.5c-11.7,0-21.2,9.5-21.2,21.2c0,11.7,9.5,21.2,21.2,21.2c11.7,0,21.2-9.5,21.2-21.2c0,0,0,0,0,0 C617.2,168.1,607.7,158.6,596,158.5z M591.7,191.1l-10.9-10.9l3-3l7.8,7.8l16.5-16.5l3,3L591.7,191.1L591.7,191.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCheckingTy9A);
export default __webpack_public_path__ + "static/media/done_checking_ty9a.3880caef17a672693d970fe416cb3589.svg";
export { ForwardRef as ReactComponent };